import type { PercentThing } from "../en/percent.ts";

/** "una camisa" -> "Una camisa" at the head of a sentence. */
const upper = (article: string) => article.charAt(0).toUpperCase() + article.slice(1);

/** Spanish percent prompts (ADR 0051 part 3). */
export const percentPrompts = {
    convertToDecimal: (percent: number) => `${percent}% = ______ en decimal`,
    convertToFraction: (percent: number) => `${percent}% = ______ como fracción sobre 100`,
    convertToPercent: (decimalStr: string) => `${decimalStr} = ______%`,
    findThePercent: (part: number, base: number) => `¿${part} es qué porcentaje de ${base}?`,
    // Shortened deliberately - ADR 0051 §7 part 3's Language sweep found the
    // fuller phrasing ran Percent of Change onto an extra page at 10 and 12
    // per page. Still a complete question in both languages.
    percentChangeRise: (base: number, percent: number) =>
        `Un precio de ${base} sube un ${percent}%. ¿Nuevo precio?`,
    percentChangeFall: (base: number, percent: number) =>
        `Un precio de ${base} baja un ${percent}%. ¿Nuevo precio?`,
    percentOf: (percent: number, base: number) => `¿Cuánto es el ${percent}% de ${base}?`,

    // Money questions (ADR 0120 §6): `$` and a decimal point, as in English,
    // and a rate written the way the lines above write a percent. Each noun
    // carries its own article so the gender is never computed.
    retailThings: [
        { article: 'una', noun: 'camisa' },
        { article: 'una', noun: 'chaqueta' },
        { article: 'una', noun: 'bicicleta' },
        { article: 'una', noun: 'lámpara' },
        { article: 'una', noun: 'mochila' },
        { article: 'un', noun: 'videojuego' },
        { article: 'un', noun: 'par de zapatos' },
        { article: 'un', noun: 'paraguas' },
    ] as PercentThing[],
    tipThings: [
        { article: 'una', noun: 'comida' },
        { article: 'un', noun: 'corte de pelo' },
        { article: 'un', noun: 'viaje en taxi' },
        { article: 'una', noun: 'pizza a domicilio' },
    ] as PercentThing[],
    salesTax: (thing: PercentThing, price: string, rate: string) =>
        `${upper(thing.article)} ${thing.noun} de ${price} tiene un ${rate}% de impuesto. ¿Costo total?`,
    tip: (thing: PercentThing, bill: string, rate: string) =>
        `${upper(thing.article)} ${thing.noun} cuesta ${bill}. Con un ${rate}% de propina, ¿cuál es el total?`,
    discount: (thing: PercentThing, price: string, rate: string) =>
        `${upper(thing.article)} ${thing.noun} de ${price} tiene un ${rate}% de descuento. ¿Precio final?`,
    markup: (thing: PercentThing, cost: string, rate: string) =>
        `Una tienda compra ${thing.article} ${thing.noun} en ${cost} y suma un ${rate}%. ¿Precio de venta?`,
    simpleInterest: (principal: string, rate: string, years: number, borrowed: boolean) =>
        borrowed
            ? `Se piden prestados ${principal} al ${rate}% de interés simple durante ${years} años. ¿Cuánto interés se debe?`
            : `Se ahorran ${principal} al ${rate}% de interés simple durante ${years} años. ¿Cuánto interés se gana?`,
};
